import { Directive, Input, OnDestroy } from '@angular/core';
import { CriticalOperationService } from '../services/critical-operation.service';

@Directive({ selector: '[appReloadGuard]', standalone: false })
export class ReloadGuardDirective implements OnDestroy {
  @Input() appReloadGuard = false;
  private readonly release: () => void;
  constructor(critical: CriticalOperationService) {
    this.release = critical.registerGuard('unsaved form', () => Boolean(this.appReloadGuard));
  }
  ngOnDestroy(): void { this.release(); }
}
